import Generate from './fake_generator'

const layers = {
  add (payload) { throw new Error('Not implemented') },
  list: [
    {
      id: 'rhizosphere',
      name: 'Rhizosphere',
      description: 'Rhizosphere or ‘underground’ dimension of plants grown for their roots and tubers.',
      borderColor: 'rgb(166, 131, 135)',
      fillColor: 'rgb(166, 131, 135, 0.2)',
    },
    {
      id: 'groundCover',
      name: 'Ground cover',
      description: 'Ground cover layer of edible plants that spread horizontally.',
      borderColor: 'rgb(137, 176, 129)',
      fillColor: 'rgb(137, 176, 129, 0.2)',
    },
    {
      id: 'herbaceous',
      name: 'Herbaceous',
      description: 'Herbaceous layer of perennial vegetables and herbs.',
      borderColor: 'rgb(149, 236, 142)',
      fillColor: 'rgb(149, 236, 142, 0.2)',
    },
    {
      id: 'shrub',
      name: 'Shrub',
      description: 'Shrub layer of fruit bushes such as currants and berries.',
      borderColor: 'rgb(163, 173, 242)',
      fillColor: 'rgb(163, 173, 242, 0.2)',
    },
    {
      id: 'lowTrees',
      name: 'Low-tree',
      description: 'Low-tree layer of smaller nut and fruit trees on dwarfing root stocks.',
      borderColor: 'rgb(253, 183, 132)',
      fillColor: 'rgb(253, 183, 132, 0.2)',
    },
    {
      id: 'canopy',
      name: 'Canopy',
      description: 'Canopy layer consisting of the original mature fruit trees.',
      borderColor: 'rgb(199, 220, 241)',
      fillColor: 'rgb(199, 220, 241, 0.2)',
    },
    {
      id: 'verticalLayer',
      name: 'Vertical',
      description: 'Vertical layer of vines and climbers.',
      borderColor: 'rgb(240, 248, 165)',
      fillColor: 'rgb(240, 248, 165, 0.2)',
    },
    {
      id: 'life',
      name: 'Life',
      description: 'Layer for the living things.',
      borderColor: 'rgb(237, 20, 91)',
      fillColor: 'rgb(237, 20, 91, 0.2)',
    },
  ],
}

export default Generate('Layers', layers, ['load'])
